<div class="color-palete" *transloco="let t">
  @for (swatch of swatches; track swatch) {
    <div class="color-palete-item"
      [ngStyle]="{ 'background-color': swatch.translationKey === 'branding.link' ? 'transparent' : swatch.hex }">
      <div class="item-bg" [ngStyle]="{ 'color': swatch.textColour }">
        <div>
          @if (swatch.colourKey !== 'link') {
            <span>
              <p>{{t(swatch.translationKey)}}</p>
              @if (showHexCodes) {
                <p>{{swatch.hex}}</p>
              }
            </span>
          }
          @if (swatch.colourKey === 'link') {
            <span>
              <a [ngClass]="type+'-link'">{{t(swatch.translationKey)}}<br>
                @if (showHexCodes) {
                  <span>
                    {{swatch.hex}}
                  </span>
                }
              </a>
            </span>
          }
          @if (editMode == 'advanced' && swatch.baseColour || editMode === 'expert') {
            <div class="input-group">
              <input class="form-control" type="text" [(ngModel)]="swatch.hex" (change)="onInputChange(swatch,'main')"
                minlength="4" />
              <span class="input-group-addon">
                <input type="color" [(ngModel)]="swatch.hex" (change)="onInputChange(swatch,'main')" size="7"
                  class="colour-picker" />
              </span>
            </div>
          }
        </div>
      </div>
      <div class="swatch-shadow align-self"
        [ngStyle]="{ 'background-color': swatch.colourKey === 'link' ? 'transparent' :  swatch.shadowHex }">
        @if (swatch.colourKey !== 'link' || editMode === 'expert') {
          <small
            [ngClass]="{'text-color' : swatch.colourKey == 'link'}">{{swatch.colourKey === 'link' ?
          t('branding.hover') : t(swatch.shadowLabel)}}</small>
        }
        @if (editMode === 'expert') {
          <div class="input-group">
            <input class="form-control" type="text" [(ngModel)]="swatch.shadowHex" (change)="onInputChange(swatch,'shadow')"
              minlength="4" />
            <span class="input-group-addon">
              <input type="color" [(ngModel)]="swatch.shadowHex" (change)="onInputChange(swatch,'shadow')" size="7"
                class="colour-picker" />
            </span>
          </div>
        }
      </div>
    </div>
  }
</div>